import * as React from 'react'
import cx from 'classnames'
import styles from './NotificationBar.sass'

interface NotificationBarProps {
  children?: React.ReactNode
  type?: 'info' | 'error'
  centered?: boolean
  dataTest?: string
}

export const NotificationBar = ({
  children,
  dataTest,
  centered = false,
  type = 'info',
}: NotificationBarProps) => {
  return (
    <div
      className={cx(
        styles.root,
        type === 'error' ? styles.error : '',
        centered && styles.centered,
      )}
      data-test={dataTest}
    >
      {children}
    </div>
  )
}

interface NotificationBarTitleProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode
  dataTest?: string
}

export const NotificationBarTitle = ({
  children,
  dataTest,
  ...rest
}: NotificationBarTitleProps) => (
  <span
    className={cx(styles.text, styles.title)}
    data-test={dataTest}
    {...rest}
  >
    {children}
  </span>
)

interface NotificationBarSubtitleProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode
  dataTest?: string
}

export const NotificationBarSubtitle = ({
  children,
  dataTest,
  ...rest
}: NotificationBarSubtitleProps) => (
  <span
    className={cx(styles.text, styles.subtitle)}
    data-test={dataTest}
    {...rest}
  >
    {children}
  </span>
)

interface NotificationBarActionProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode
  dataTest?: string
}

export const NotificationBarAction = ({
  children,
  dataTest,
  ...rest
}: NotificationBarActionProps) => (
  <a className={cx(styles.text, styles.action)} data-test={dataTest} {...rest}>
    {children}
  </a>
)
